/* eslint-disable react-native/no-inline-styles */
import React, { Component } from 'react'
import {
  View,
  TouchableWithoutFeedback,
  Animated,
  Easing,
  TouchableOpacity,
} from 'react-native'
import _ from 'lodash'
import PropTypes from 'prop-types'
import ContentLoader, { Rect } from 'react-content-loader/native'

import { VFText, Icon, BlinkView } from '@vfgroup-oneplatform/foundation/Components'
import { Images, Types, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import styles from './CollapsibleItem.Styles'

class CollapsibleItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpend: props.isOpend,
      animatedIcon: new Animated.Value(0),
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.isOpend !== state.isOpend) {
      Animated.timing(state.animatedIcon, {
        toValue: props.isOpend ? 1 : 0,
        duration: 200,
        easing: Easing.linear,
        useNativeDriver: true,
      }).start()
      return {
        isOpend: props.isOpend,
      }
    }

    return null
  }

  render() {
    const {
      title,
      titleStyle,
      desc,
      icon,
      content,
      type,
      disabled,
      isOpend,
      onPress,
      onItemPress,
      index,
      isBlinking,
      status,
      isLoading,
      style,
      theme
    } = this.props

    const { animatedIcon } = this.state
    const isPrimary = type === Types.PRIMARY
    let openColseIcon = ''
    isPrimary
      ? (openColseIcon = Images.ic_chevron_down_red)
      : (openColseIcon = Images.ic_chevron_down_white)

    const iconStyle = isPrimary ? {} : styles.iconSecondery
    const spin = animatedIcon.interpolate({
      inputRange: [0, 1],
      outputRange: ['0deg', '-180deg'],
    })

    return (
      <View
        style={{ ...styles.container, ...style }}
        accessibilityLabel={`checkItemLayout${index}`}
      >
        <View style={styles.headdingContainer}>
          <TouchableOpacity
            onPress={() => onItemPress()}
            disabled={isLoading}
            style={styles.headingTouchable}
          >
            <View style={styles.textWithIcon}>
              <BlinkView disabled={!isBlinking}>
                <Icon
                  type="image"
                  name={icon}
                  size={36}
                  style={[iconStyle, status === 2 ? styles.opacityStyle : null]}
                  resizeMode="contain"
                />
              </BlinkView>
              <View style={{ flex: 1 }}>
                {isLoading
                  ? <ContentLoader
                    speed={2}
                    width={232}
                    height={48}
                    backgroundColor={theme.colors.shimmerCenterColor}
                    foregroundColor={theme.colors.shimmerEdgesColor}
                  >
                    <Rect x="16" y="3" rx="6" ry="6" width="160" height="16" />
                    <Rect x="16" y="26" rx="6" ry="6" width="200" height="16" />
                  </ContentLoader>
                  :
                  <View style={styles.titleContainer}>
                    <VFText
                      style={[styles.headdingText, titleStyle]}
                      i18nKey={title}
                      type={type}
                      accessibilityLabel={`checkItemTitle${index}`}
                    />
                    {_.isFunction(desc) && desc()}
                  </View>}
              </View>
            </View>
          </TouchableOpacity>
          <TouchableOpacity onPress={onPress} disabled={disabled} style={styles.touchableIcon}>
            <Animated.View
              style={{
                transform: [{ rotate: spin }, { perspective: 1000 }],
              }}
            >
              <Icon
                type="image"
                name={openColseIcon}
                size={24}
                resizeMode="contain"
                accessibilityLabel="EIOdetailsArrow"
              />
            </Animated.View>
          </TouchableOpacity>
        </View>
        <TouchableWithoutFeedback>
          {isOpend
            ? <View style={styles.contentContainer}>
              {content}
            </View>
            : <View />
          }
        </TouchableWithoutFeedback>
      </View>
    )
  }
}

CollapsibleItem.propTypes = {
  title: PropTypes.string,
  titleStyle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  desc: PropTypes.func,
  icon: PropTypes.string,
  content: PropTypes.any,
  status: PropTypes.any,
  type: PropTypes.oneOf([Types.PRIMARY, Types.SECONDARY]),
  disabled: PropTypes.bool,
  index: PropTypes.number,
  isOpend: PropTypes.number || undefined,
  onPress: PropTypes.func,
  onItemPress: PropTypes.func,
  isBlinking: PropTypes.bool,
  isLoading: PropTypes.bool,
  style: PropTypes.object,
}

CollapsibleItem.defaultProps = {
  disabled: false,
  isBlinking: false,
  isLoading: false,
}

export default withTheme(CollapsibleItem)
